import { required } from 'ra-core';
import { AutocompleteInput } from '../../components/admin/autocomplete-input';
import { ReferenceInput } from '../../components/admin/reference-input';
import { TextInput } from '../../components/admin/text-input';
import { MoonstarEdit } from '../Moonstar/MoonstarEdit';
import { MoonstarEditForm } from '../Moonstar/MoonstarEditForm';
import { SimpleStack } from '../Moonstar/SimpleStack';

export const TopicEdit = () => (
  <MoonstarEdit redirect="list">
    <MoonstarEditForm>
      <SimpleStack>
        <TextInput source="displayName" validate={required()} />
        <ReferenceInput source="formTypeId" reference="formTypes">
          <AutocompleteInput
            optionText="typeName"
            readOnly
            validate={required()}
            filterToQuery={(searchText) => ({ typeName: searchText })}
          />
        </ReferenceInput>
      </SimpleStack>
    </MoonstarEditForm>
  </MoonstarEdit>
);
